import api from '../../plugins/api';

// ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð±ÑÐº Ð±ÐµÑÑÑ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸ â Ð² Ð·Ð°Ð¿ÑÐ¾ÑÐµ ÐµÐ³Ð¾ Ð½ÐµÑ.
const sendClientUploadSms = ({ dealId, kinds }) => {
  return api.post('/api/crm/clientUpload/sendSms', { dealId, kinds });
};

export default sendClientUploadSms;
